export default __webpack_public_path__ + "static/media/lds-logo_pl.2bbc8ac66fe483d6.svg";